import classNames from 'classnames';

type Props = {
  className?: string;
  heading: string | JSX.Element;
  strapline?: string | JSX.Element;
  byline?: string | JSX.Element;
  align?: 'left' | 'center';
};

const PageHeading: React.FC<Props> = ({
  align = 'left',
  byline,
  className,
  heading,
  strapline,
}) => {
  return (
    <div
      className={classNames('flex w-full max-w-lg flex-col', {
        'mx-auto text-center': align === 'center',
        className,
      })}
    >
      <div className="w-full flex-1 space-y-2">
        <h1 className="text-md font-bold md:text-lg">{heading}</h1>
        {strapline && (
          <h2 className="md:text-md" role="doc-subtitle">
            {strapline}
          </h2>
        )}
      </div>
      {byline && (
        <div className="w-full flex-1">
          <p className="text-neutral-4">{byline}</p>
        </div>
      )}
    </div>
  );
};

export default PageHeading;
